import { Flex, Stack, FlexItem } from '@pairy/pds-react';

import Pairy from './Pairy';
import Sites from './Sites';

const Footer = () => {
  return (
    <Stack
      gap={32}
      justifyContent="center"
      backgroundColor="zinc_900"
      padding={{ x: 16, y: 96 }}
      direction="column"
    >
      <Stack gap={16} direction="column">
        <Pairy />
      </Stack>
      <Flex>
        <FlexItem flexGrow={1}>
          <Sites />
        </FlexItem>
      </Flex>
    </Stack>
  );
};

export default Footer;
